/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Redirect, Link } from 'react-router-dom';

@observer
export default class TermsComponent extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 ">
                        <hr />
                        <h2 id="">Help</h2>
                        <hr />
                        <p>
                            deliver.media <br />
                            <strong>SMP Solutions GmbH</strong> <br />
                            Platz 3 <br />
                            CH-6039 Root D4 <br />
                            Switzerland
                            <br />
                            Tel: +41 41 511 32 77
                        </p>

                        <div className="card-deck mb-3 text-center">
                            <div className="card mb-4 box-shadow">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Worldwide</h4>
                                </div>
                                <div className="card-body">
                                    <h4 className="card-title pricing-card-title">SMP Solutions GmbH</h4>
                                    <a
                                        target="_blank"
                                        href="mailto:mail@smpsolutions.ch"
                                        className="btn btn-lg btn-block btn-primary"
                                    >
                                        Support
                                    </a>
                                </div>
                            </div>
                            <div className="card mb-4 box-shadow">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Switzerland</h4>
                                </div>
                                <div className="card-body">
                                    <h4 className="card-title pricing-card-title">SwissMediaPartners AG</h4>
                                    <a
                                        target="_blank"
                                        href="https://support.swissmediapartners.ch"
                                        className="btn btn-lg btn-block btn-primary"
                                    >
                                        Support
                                    </a>
                                </div>
                            </div>
                            <div className="card mb-4 box-shadow">
                                <div className="card-header">
                                    <h4 className="my-0 font-weight-normal">Germany</h4>
                                </div>
                                <div className="card-body">
                                    <h4 className="card-title pricing-card-title">ON AIR Digital</h4>
                                    <a
                                        target="_blank"
                                        href="https://onair.zendesk.com"
                                        className="btn btn-lg btn-block btn-primary"
                                    >
                                        Support
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
